import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  scenicAccordionItem: {
    width: '100%',
    height: '100%',
    background: theme.palette.blue.light100,
    position: 'relative',
  },
  bgImageContainer: {
    position: 'absolute',
    top: 45,
    left: 0,
    height: 'calc(100% - 85px)',
    width: '100%',
    zIndex: 0,
  },
  bgImage: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  saiCardContainer: {
    padding: '0 32px 12px',
    position: 'relative',
  },
  saiCard: {
    width: '100%',
    padding: '40px 34px',
    borderRadius: 8,
    background: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    textAlign: 'left',
    position: 'relative',
  },
  heading: {
    ...theme.typography.h2,
    marginBottom: 20,
    marginTop: 12,
  },
  supportiveCopy: {
    maxWidth: 732,
    marginBottom: 40,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  middle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '2rem',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: ({ offset }) => `${offset + 20}px`,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '1rem',
    },
    '&>p': {
      color: theme.palette.text.primary,
    },
  },
  richTextWrapper: {
    padding: 0,
    '&>div>div>a': {
      color: theme.palette.blue.main,
      fontWeight: 700,
      boxShadow: 'none',
      textDecoration: 'underline',
    },
  },
  left: {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  right: {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  bottom: {
    borderRadius: '0 0 8px 8px',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    background: theme.palette.background.default,
    position: 'absolute',
    bottom: '0',
    left: 0,
    right: 0,
    padding: '32px 34px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  bottomText: {
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&>p>div>div': {
      marginBottom: '0 !important',
    },
    '&>p>div>div>a': {
      boxShadow: 'none',
    },
    '&>p>div>div>a>u': {
      color: theme.palette.blue.main,
      fontWeight: 700,
    },
    '&>div>div>a': {
      color: theme.palette.blue.main,
      fontWeight: 700,
      boxShadow: 'none',
      textDecoration: 'underline',
    },
  },
  ctaButton: {
    paddingRight: 0,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  },
  tabPanelHeading: {
    ...theme.typography.h5,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: 0,
  },
  tabPanelsupportiveCopy: {
    color: theme.palette.text.primary,
    [theme.breakpoints.up(1400)]: {
    },
  },
}))

export default useStyles
